export const state = (): CreditCode => ({
  creditCodeValue: null
})

export const GET_CREDIT_CODE_VALUE = "getCreditCodeValue"

export const getters = {
  [GET_CREDIT_CODE_VALUE]: (state: CreditCode): number | null => state.creditCodeValue
}

export const _SET_CREDIT_CODE_VALUE = "setCreditCodeValue"

export const mutations = {
  [_SET_CREDIT_CODE_VALUE](state: CreditCode, creditCodeValue: number) {
    state.creditCodeValue = creditCodeValue
  }
}

export const SET_CREDIT_CODE_VALUE = "setCreditCodeValue"

export const actions = {
  [SET_CREDIT_CODE_VALUE]({ commit }, creditCodeValue: number) {
    commit(_SET_CREDIT_CODE_VALUE, creditCodeValue)
  }
}
